import { differenceInDays } from 'date-fns';

export const getFreeTrialDaysLeft = (freeTrialEndDate: string | null | undefined, now: Date): number => {
  const endDate = new Date(freeTrialEndDate ?? 0);

  if (endDate.getTime() <= now.getTime()) {
    return 0;
  }

  return differenceInDays(endDate, now) + 1;
};
